'use client';

import { useState } from 'react';

import {
  srcSetWidths as defaultSrcSetWidths,
  generateSrcSet,
} from '@core/Components/HeycarImage/GenerateSrcSet';
import { clampSrcSetWidths } from '@umbraco/Utils/ClampSrcSetWidths';
import { umbracoImageLoader } from '@umbraco/Utils/UmbracoImageLoader';

import styles from './ReviewBody.module.css';

interface ReviewImageProps {
  src: string;
  alt: string;
  width?: number;
}

const ReviewImage = ({ src, alt, width }: ReviewImageProps) => {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return <div className={styles.imgPlaceholder} aria-hidden />;
  }

  return (
    <img
      className={styles.reviewImage}
      src={src}
      srcSet={generateSrcSet(
        src,
        umbracoImageLoader,
        clampSrcSetWidths(defaultSrcSetWidths, width),
      )}
      alt={alt}
      sizes="(min-width: 1024px) 50vw, 100vw"
      loading="lazy"
      onError={() => setErrored(true)}
    />
  );
};

export default ReviewImage;
